import {formatServerDate} from "./EventCountdown.jsx";
import {EventPlayer} from "./EventPlayer.jsx";

// The member's own entry, shown the same way everywhere it appears: the
// manage page, the uploader's current-entry block and the account page's
// submissions list. The entry is embedded directly (no play click) — owner
// playback never creates view sessions, so this pollutes no analytics.
// Page-specific actions (withdraw, manage links, closed notes) render as
// children below the player.
export function EventEntryCard({submission, skew = 0, children}) {
    const updatedLabel = formatServerDate(submission.date_updated || submission.date_added, skew);

    return (
        <div className="border border-white/10 rounded-lg p-4 text-left">
            {submission.source_type === "youtube" && submission.youtube_id ? (
                <a
                    href={`https://www.youtube.com/watch?v=${encodeURIComponent(submission.youtube_id)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-blue-400 hover:underline truncate block"
                >
                    {`youtu.be/${submission.youtube_id}`}
                </a>
            ) : (
                <div className="font-medium truncate">{submission.original_filename || "Your uploaded file"}</div>
            )}
            <div className="text-xs text-gray-400 mt-1">
                {`Entered as "${submission.display_name}" · `}
                {submission.source_type === "youtube" ? "YouTube link" : submission.media_type}
                {updatedLabel ? ` · last updated ${updatedLabel}` : ""}
            </div>
            {submission.status === "hidden" && (
                <div className="text-xs text-yellow-400 mt-2">
                    This entry has been hidden by a moderator and is not visible to other members.
                </div>
            )}
            <div className="mt-3">
                <EventPlayer submissionId={Number(submission.id)} mediaType={submission.media_type}/>
            </div>
            {children}
        </div>
    );
}
